import $ from 'jquery';
import 'jquery.cookie';
import {
    Router,
    history
} from 'backbone';
import URI from 'urijs';

import Settings from 'source/lib/settings_model';
import messages from 'messages';

import gtmInclude from 'source/lib/utils/gtm_include';

import FooterView from './parts/footer';
import CommonMenuView from './parts/commonmenu';
import WrapperView from './wrapper';
import NotFoundView from './404';

const IDRouter = Router.extend({
    routes: {
        'signin/': 'signin',
        'confirmation/': 'confirm',
        'signin/external/unbound/': 'unbound',
        'recovery/': 'recover',
        '*handleMissingRoute': 'handle404'
    },
    views: {},
    initialize() {
        this.setTitle();
        this.initGtmScript();
        Settings.onUpdate().then(() => {
            this.initializeWrapper();
            const baseUrl = Settings.get('urls.BaseIDUrl', '/id/');
            history.start({
                root: baseUrl,
                pushState: true
            });
            this.initializeCommonMenu();
            this.initializeFooter();
        });
        Settings.startSync();
    },
    isAuthenticated() {
        const cookieName = Settings.get('App.IsAuthenticatedCookieName');
        return $.cookie(cookieName) === 'yes';
    },
    initGtmScript() {
        const gtmSettings = Settings.get('General.GoogleTagManager');
        if (gtmSettings) {
            const gtmKey = this.isAuthenticated()
                ? gtmSettings.AuthenticatedKey
                : gtmSettings.AnonymousKey;

            const urlTemplate = gtmSettings.UrlTemplate;
            if (gtmKey && urlTemplate) {
                const url = urlTemplate.replace('%s', gtmKey);
                gtmInclude(url);
                return;
            }
        }
        if (Settings.updated) {
            return;
        }
        Settings.onUpdate().then(() => this.initGtmScript());
    },
    initializeWrapper() {
        this.views.wrapper = new WrapperView({
            el: 'body'
        });
    },
    initializeCommonMenu() {
        this.views.commonMenuView = new CommonMenuView({
            el: '#js-menu-loader'
        });
    },
    initializeFooter() {
        this.views.footerView = new FooterView({
            el: '#js-footer'
        });
    },
    signin() {
        const isAuthenticated = Settings.get('Request.AccountInfo.IsAuthenticated');
        if (isAuthenticated) {
            const accountEmail = Settings.get('Request.AccountInfo.Email');
            let nextUrl;
            if (accountEmail) {
                nextUrl = Settings.get('Request.NextUrl');
            } else {
                nextUrl = Settings.get('Request.IncompleteUrl');
            }
            this.routeByUrl(nextUrl);
            return;
        }
        const handler = System.import('./index.js');
        this.initializeRoute(handler);
    },
    confirm() {
        const isAuthenticated = Settings.get('Request.AccountInfo.IsAuthenticated');
        if (!isAuthenticated) {
            this.routeByUrl(Settings.get('Authentication.LoginUrl'));
            return;
        }

        let OIDUrlPattern;
        try {
            const OIDUrl = Settings.get('Authentication.OIDUrl', '/id/openid/');
            OIDUrlPattern = new RegExp(`${OIDUrl}\\d+/`);
        } catch (e) {
            console.log(e);
        }
        if (OIDUrlPattern && !OIDUrlPattern.test(Settings.get('Request.TrustedNextUrl'))) {
            this.handle404();
            return;
        }
        const handler = System.import('./confirm.js');
        this.initializeRoute(handler, messages.texts.confirm_page_title);
    },
    recover() {
        const handler = System.import('./recover.js');
        this.initializeRoute(handler);
    },
    unbound() {
        const { flow } = URI.parseQuery(window.location.search);
        const isAuthenticated = Settings.get('Request.AccountInfo.IsAuthenticated');
        const nextLocation = Settings.get('Request.NextLocation');
        const isGameFlow = Settings.get('Authentication.GameEnabled') && flow === 'game';
        if (!isAuthenticated || !isGameFlow) {
            this.routeByUrl(nextLocation);
            return;
        }

        /*
            TODO: remove in scope of WGNI-1257
            temporary fix made for demo account compatibility:
                Account don't have external email.
                Skip bind step and redirect to client
        */
        const accountEmail = Settings.get('Request.AccountInfo.Email');
        if (!accountEmail) {
            const url = new URI(nextLocation);
            url.removeQuery('external');
            this.routeByUrl(url.toString());
            return;
        }

        const handler = System.import('./unbound.js');
        this.initializeRoute(handler);
    },
    routeByUrl(url) {
        const baseUrl = Settings.get('urls.BaseIDUrl', '/id/');
        if (url.indexOf(baseUrl) === 0) {
            const nextUrl = new URI(url.substring(baseUrl.length));
            if (this.routes[`${nextUrl.path()}`]) {
                Settings.syncAccountState().then(() => {
                    this.navigate(nextUrl.toString(), { trigger: true });
                });
                return;
            }
        }
        window.location.href = url;
    },
    setTitle(title) {
        window.document.title = `${title ? `${title} | ` : ''}${messages.texts.base_title}`;
    },
    initializeRoute(handler, title) {
        handler.then(bundle => {
            Settings.onUpdate().then(() => {
                this.viewBundle = bundle.default;
                this.viewBundle({ router: this });
                this.setTitle(title);
            });
        });
    },
    handle404() {
        this.setTitle(messages.texts['404_title']);
        if (this.notFoundView) {
            this.notFoundView.render();
        } else {
            this.notFoundView = new NotFoundView({
                el: '#js-view'
            });
        }
    }
});

export default IDRouter;



// WEBPACK FOOTER //
// ./authentication/static-source/js/authentication/router.js